import React from 'react';
import PropTypes from 'prop-types';

import './_Button.scss';

import { IoIosArrowForward } from 'react-icons/io';
import CircularProgress from '@material-ui/core/CircularProgress';

function Button(props) {
    let mod_class = [
        'Button',
        props.className ? props.className : '',
        props.theme !== undefined ? 'theme-' + props.theme : '',
        props.radius !== undefined ? 'radius-' + props.radius : '',
        props.variant !== undefined ? 'variant-' + props.variant : '',
        props.align !== undefined ? 'align-' + props.align : '',
        props.size !== undefined ? 'size-' + props.size : '',
        props.isMobileFullsize ? 'is-mobileFullsize' : '',
        props.isFullsize ? 'is-fullsize' : '',
        props.isLoading ? 'is-loading' : '',
        props.classes,
    ];

    mod_class = mod_class.join(' ');

    const handleClick = (e) => {
        if (props.onClick) props.onClick(e);
        if (typeof window !== 'undefined' && props.externalLink) {
            window.open(props.externalLink, '_blank');
        }
    };

    function renderDOM() {
        return (
            <>
                <button
                    id={props.id}
                    className={mod_class}
                    type={props.type}
                    disabled={props.disabled || props.isLoading}
                    onClick={handleClick}
                >
                    <span className="Button--label">
                        {props.label}

                    </span>
                    {props.isLoading && <CircularProgress className="Button--loader" size="20" />}

                    {props.icon ? (
                        <i className="Button--icon">{props.icon}</i>
                    ) : (
                        ''
                    )}



                    {props.iconArrow ? (
                        <i className="Button--icon">
                            <IoIosArrowForward />
                        </i>
                    ) : (
                        ''
                    )}
                </button>
            </>
        );
    }

    return renderDOM();
}

Button.propTypes = {
    theme: PropTypes.oneOf([
        'dark',
        'highlighted',
        'white',
        'danger',
        'ghosted',
        'light',
        'pink-gradient',
    ]),
    variant: PropTypes.oneOf([
        'primary',
        'outlined',
        'inline',
        'naked',
        'mini',
        'pills',
        'round',
    ]),
    label: PropTypes.string,
    onClick: PropTypes.func,
    align: PropTypes.any,
    iconArrow: PropTypes.bool,
    classes: PropTypes.string,
    id: PropTypes.string,
    icon: PropTypes.node,
    radius: PropTypes.radius,
    externalLink: PropTypes.string,
};

Button.defaultProps = {
    type: 'button', // submit
    theme: 'dark', // highlighted, white,
    variant: 'primary', // outlined, inline, naked, squared, mini, pills
    size: 'm', // l, s
    isMobileFullsize: false,
    disabled: false,
};

export default Button;
